import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export default styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
}));
